export default __webpack_public_path__ + "static/media/medibuddyFooter.72c7ba52.png";